export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/RewardPoints.ea673322.svg","height":100,"width":89,"blurWidth":0,"blurHeight":0};